import { render, staticRenderFns } from "./prop.vue?vue&type=template&id=42aeb4dc&scoped=true&"
import script from "./prop.vue?vue&type=script&lang=js&"
export * from "./prop.vue?vue&type=script&lang=js&"
import style0 from "./prop.vue?vue&type=style&index=0&id=42aeb4dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aeb4dc",
  null
  
)

export default component.exports